import RowGrid from '@/components/reusables/dashboard/RowGrid';
import RecentProducts from './RecentProducts';
import RecentQRScanActivity from './RecentQRScanActivity';
import TopScannedProducts from './TopScannedProducts';
import {
  useFetchAllownerdashboard,
  useFetchFailedImportCountForOwner,
} from '@/hooks/dashboardHooks';
import { useNavigate } from 'react-router';
import DashboardCard from '@/components/reusables/dashboard/DashboardCard';
import { Box, CircleParkingOff, ScanBarcode, TriangleAlert } from 'lucide-react';
import { useCallback, useMemo } from 'react';
import DashboardSkeleton from '@/components/reusables/DashboardSkeleton';

const DashboardMainComp = () => {
  const { data: count, isLoading, isError, isFetching } = useFetchAllownerdashboard();
  const { data: faildImport } = useFetchFailedImportCountForOwner();
  const navigate = useNavigate();

  const { vendorCount = 0, discontinuedProductCount = 0, totalScannedProducts = 0 } = count || {};
  const { failedImportCount = 0 } = faildImport || {};

  const navigateToTab = useCallback(
    (tab: string) => {
      navigate(`/owner/reports?tab=${tab}`);
    },
    [navigate]
  );

  const dashboardCards = useMemo(
    () => [
      {
        title: 'Total Active Vendors',
        value: vendorCount,
        icon: Box,
        onClick: () => navigateToTab('active-vendors'),
      },
      {
        title: 'Total Scanned Products',
        value: totalScannedProducts,
        icon: ScanBarcode,
        onClick: () => navigateToTab('scanned-products'),
      },
      {
        title: 'Total Discontinued Products',
        value: discontinuedProductCount,
        icon: CircleParkingOff,
        onClick: () => navigateToTab('discontinued-products'),
      },
      {
        title: 'Total Failed Imports',
        value: failedImportCount,
        icon: TriangleAlert,
        onClick: () => navigateToTab('failed-imports'),
      },
    ],
    [vendorCount, totalScannedProducts, discontinuedProductCount, failedImportCount, navigateToTab]
  );

  if (isLoading || isFetching) {
    return (
      <div className="itemcenter flex justify-center">
        <DashboardSkeleton />
      </div>
    );
  }

  if (isError) {
    return <div className="itemcenter text-center text-red-500">Failed to load dashboard data</div>;
  }

  return (
    <div className="dashboard-content-wrap">
      <div className="mb-6 grid grid-cols-4 gap-5">
        {dashboardCards.map((card) => (
          <div key={card.title} className="d-card-item cursor-pointer" onClick={card.onClick}>
            <DashboardCard title={card.title} value={card.value} icon={card.icon} />
          </div>
        ))}
      </div>

      <RowGrid className="mb-8">
        <RecentQRScanActivity />
        <TopScannedProducts />
      </RowGrid>

      <RecentProducts />
    </div>
  );
};

export default DashboardMainComp;
